// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20xCB","rootNoMargin":"styles_rootNoMargin__1U-B2"};